import { Injectable } from '@angular/core';
import moment from 'moment-timezone';

const DEFAULT_TIMEZONE = 'America/Chicago';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {
  constructor() {}

  public getTimezoneOffset(date: Date) {
    return moment.tz(moment(date).format('YYYY-MM-DD HH:mm:ss'), DEFAULT_TIMEZONE).format('Z z');
  }

  public shiftToLocal(date: Date) {
    return new Date(moment.tz(date, DEFAULT_TIMEZONE).format('YYYY-MM-DD HH:mm:ss'));
  }

  public shiftFromLocal(date: Date) {
    return moment.tz(moment(date).format('YYYY-MM-DD HH:mm:ss'), DEFAULT_TIMEZONE).toDate();
  }

  public getISODate(date: Date) {
    return moment(date).format('YYYY-MM-DD');
  }
}
